import React from 'react';
import {
  StyleSummaryCardContainer,
  SummaryCardTitle,
  SummaryDataContainer,
  SummaryInfosContainer,
  SummaryInfosTextContainer,
  SummaryInfosTitle,
  SummaryInfosTitlesContainer,
  SummaryButtonBlockContainer,
  SummaryButtonBlockColumn,
  SummaryHeaderContainer,
} from './styled.summarySkeleton';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { v4 } from 'uuid';

export function SummarySkeleton () {
  return (
    <>
      <SummaryHeaderContainer>
        <Skeleton width={100} />
      </SummaryHeaderContainer>
      {[0, 1, 2].map((index) => (
        <StyleSummaryCardContainer key={v4()}>
          <SummaryCardTitle>
            <Skeleton />
          </SummaryCardTitle>

          <SummaryDataContainer>
            <Skeleton circle={true} width={100} height={100} />
            <SummaryInfosContainer>
              <SummaryInfosTextContainer>
                <SummaryInfosTitlesContainer>
                  <SummaryInfosTitle>
                    <Skeleton />
                  </SummaryInfosTitle>
                  <SummaryInfosTitle>
                    <Skeleton />
                  </SummaryInfosTitle>
                </SummaryInfosTitlesContainer>
                <SummaryInfosTitlesContainer>
                  <SummaryInfosTitle>
                    <Skeleton />
                  </SummaryInfosTitle>
                  <SummaryInfosTitle>
                    <Skeleton />
                  </SummaryInfosTitle>
                </SummaryInfosTitlesContainer>
              </SummaryInfosTextContainer>
              <SummaryInfosTitlesContainer>
                <SummaryInfosTitle>
                  <Skeleton />
                </SummaryInfosTitle>
                <SummaryInfosTitle>
                  <Skeleton />
                </SummaryInfosTitle>
                <SummaryInfosTitle>
                  <Skeleton />
                </SummaryInfosTitle>
              </SummaryInfosTitlesContainer>
            </SummaryInfosContainer>
          </SummaryDataContainer>
        </StyleSummaryCardContainer>
      ))}
      <SummaryButtonBlockContainer>
        <SummaryButtonBlockColumn>
          <Skeleton height={48} />
        </SummaryButtonBlockColumn>
      </SummaryButtonBlockContainer>
    </>
  );
}
